import { ErrorMessage } from './keyword_detail_condition_env';
import { HistorySuggest } from "./history_suggest";
import { KeywordDetailJsEnv } from './keyword_detail_js_env';
import { Suggest } from "./suggest";

export class KeywordDetail {
  constructor(private model: KeywordDetailJsEnv) {
    this.model = { ...model };
    this.model.errorMessage = new ErrorMessage('', '');
    this.clearSuggest();
  }

  getModel(): KeywordDetailJsEnv {
    return this.model;
  }

  setErrorMessage(errorTitle: string, errorContent: string) {
    this.model.errorMessage.title = errorTitle;
    this.model.errorMessage.content = errorContent;
  }

  setHistorySuggest(historySuggest: HistorySuggest) {
    this.model.historySuggest = historySuggest;
  }

  setSuggest(suggest: Suggest) {
    this.model.suggest = suggest;
  }

  clearSuggest() {
    this.model.historySuggest = null;
    this.model.suggest = null;
  }
}
